import { render, staticRenderFns } from "./Programming.vue?vue&type=template&id=fa484460&scoped=true&"
import script from "./Programming.vue?vue&type=script&lang=js&"
export * from "./Programming.vue?vue&type=script&lang=js&"
import style0 from "./Programming.vue?vue&type=style&index=0&id=fa484460&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa484460",
  null
  
)

export default component.exports